<template>
  <div class="detail-container">
    <h1 class="page-title">建物種別マスタ情報詳細</h1>
    <div v-if="building_type">
      <table class="table table-bordered">
        <tr>
          <th>ID</th>
          <td>{{ building_type.id }}</td>
        </tr>
        <tr>
          <th>建物種別</th>
          <td>{{ building_type.building_type_nm }}</td>
        </tr>
        <tr>
          <th>並び順</th>
          <td>{{ building_type.sort_no }}</td>
        </tr>
      </table>

      <div class="btn-area">
        <router-link :to="{ name: 'BuildingTypeList', params: { id: building_type.id }, query: route.query }"> <!-- 顧客情報編集ページへのリンク -->
          <button type="button" class="btn btn-primary">一覧へ</button>
        </router-link>

        <router-link v-if="userRole == 0 || userRole == 999" :to="{ name: 'BuildingTypeEdit', params: { id: building_type.id }}"> <!-- 顧客情報編集ページへのリンク -->
          <button type="button" class="btn btn-success mx-2">編集</button>
        </router-link>
      </div>
    </div>
    <!-- その他の詳細情報 -->
    <div v-else>
      建物種別情報情報を読み込み中...
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { getBuildingType } from '@/api/axios';

export default {
  setup() {
    const title = ref('建物種別情報詳細');

    watchEffect(() => {
      document.title = title.value;
    });

    const store = useStore();
    const route = useRoute();
    const userRole = computed(() => store.state.userRole);
    const building_type = ref({});
    const buildingTypeId = route.params.id;

    const fetchBuildingType = async () => {
      const response = await getBuildingType(buildingTypeId);
      building_type.value = response.data;
    };

    onMounted(fetchBuildingType);

    return {
      title,
      userRole,
      building_type,
      route
    };
  }
};
</script>
